
import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link, useNavigate } from 'react-router-dom';
import {auth, sendPasswordReset, emailValidation } from './firebase';
import './Reset.css';


function Reset() {
  const [email, setEmail] = useState("");
  const [user, loading] = useAuthState(auth);    
  const navigate = useNavigate();

  useEffect(() => {
      if (loading) return;
      if (user) navigate("/home");
  }, [user, loading]);

  const onChangeEmail=(event) => {
    setEmail(event.target.value);
    if (!emailValidation(event.target.value)) {
      document.getElementById('email_reset').style.color = 'red';
      document.getElementById('email_reset').style.border = '2px solid red';
    }else{
      document.getElementById('email_reset').style.color = 'green'
      document.getElementById('email_reset').style.border = '2px solid green'
    }
  }

  return (
    <div className="register">
      <div>
        <img className='logo__carbonbox' src='/logo-carbonbox-full.svg' alt='logo carbonbox'></img>    
        
      </div>
      <div className="reset__container">
      <label className='texto__informativo' >Correo electrónico de recuperación</label>
          <input id='email_reset'
            type="text"
            className="reset__textBox"
            value={email}
            //onChange={(e) => setEmail(e.target.value)}
            onChange={onChangeEmail}
            placeholder="Correo electrónico"
          />
          <button
            className="reset__btn font__family"
            onClick={() => sendPasswordReset(email)}
          >
            Enviar correo de recuperación de contraseña
          </button>
          {/*<div>
            ¿Aún no tengo una cuenta? <Link to="/register">Registrese.</Link>
          </div>*/}
        </div>
      <Link to='/' style={{width:'235px'}} className="register__btn font__family" >Ir a Inicio de Sesión 
      </Link>
    </div>
  )
}

export default Reset;











/*function Reset() {
    const [email, setEmail] = useState("");
    const [user, loading, error] = useAuthState(auth);    
    const navigate = useNavigate();

    useEffect(() => {
        if (loading) return;
        if (user) navigate("/dashboard");
    }, [user, loading]);

    return (
      <div className="reset">
        <div className="reset__container">
          <input
            type="text"
            className="reset__textBox"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Correo electrónico"
          />
          <button
            className="reset__btn"
            onClick={() => sendPasswordReset(email)}
          >
            Enviar correo de recuperación de contraseña
          </button>
          <div>
            ¿Aún no tengo una cuenta? <Link to="/register">Registrese.</Link>
          </div>
        </div>
      </div>
    )
}

export default Reset;*/
